<template>
  <div class="price-card"  @click="goDetail(cardData.id)" >
    <div class="tip" v-if=" $store.state.plat_id!='120' || type!='live'">
            <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2是  1不是-->
            <img :src="$free" v-if="cardData.is_free==2"/>
            <img :src="$vip" v-else-if="cardData.is_vip_flat==1"/>
            <img :src="$noVip" v-else>
    </div>
    <van-image class="price-cover" fit="cover" 
    :error-icon="$placeImg"
    :loading-icon="$placeImg"
     :src="cardData.cover_mobile || cardData.img_url" alt=""></van-image>
    <div class="price-msg">
      <div class="priceName">
        <div class="price-name ellipsis_two">{{ cardData.name }}</div>
        <div class="priceYingyou">¥ {{ cardData.price }}</div>
      </div>
      <div class="price-des" v-if="cardData.description">{{ cardData.description }}</div>
      <!-- <div class="time">76人学习 共79学时（线上56学时，线下26学时）</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
    type: {
      type:String,
      default : ''
    }
  },
  computed: {
    plat() {
      return this.$store.state.plat_id
    },
  },
  data() {
    return {};
  },
  methods: {
    goDetail(id) {
      let url = `./detail2?id=${id}`
     
      this.$router.push(url);
    },
  },
};
</script>

<style scoped lang="scss">
.price-card {
  width: calc(100% - 60px);
  margin: 0 auto 26px;
  box-sizing: border-box;
  position: relative;
  background: #fff;
  border-radius: 12px;

  .tip{
    position: absolute;
    top:0;
    left:30px;
    z-index: 1;
    img{
      width: 78px;
      height: 35px;
    }
  }
}

.price-card:last-of-type {
  /* margin-bottom: 0; */
}

.price-cover {
  width: 100%;
  border-radius: 12px;
  display: block;
  overflow: hidden;
}

.price-msg {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  padding: 0 30px 32px;

}
 .priceName{
  display: flex;
  width: 100%;
  padding: 24px 0 16px;
  .price-name{
    flex: 1
  }
 }
.price-name {
  font-size: 28px;
  color: #000;
  font-weight: 500;
  width: 100%;
  margin-bottom: 10px;
}

.price-des {
  font-size: 20px;  
  color: #999;
  line-height: 28px;
  font-weight: 400;
  width: 100%;
  margin-bottom: 32px;
}

.priceYingyou {
  font-size: 32px;
  color: #F08E00;
  font-weight: 500;
}
.time{
  width: 100%;
  height: 54px;
  background: #FFF0DE;
  border-radius: 8px;
  font-size: 20px;
  font-weight: 400;
  color: #F08E00;
  line-height: 54px;
  padding-left: 24px;
  box-sizing: border-box;
}
</style>>
